(function () {
  // Base path for all jackpot trail resources
  const JACKPOT_BASE_PATH = 'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters';

  // Jackpot configuration - defines the mapping between coin symbols and jackpot levels
  const JACKPOT_CONFIG = {
    15: {
      name: 'mini',
      index: 0,
      maxNodes: 2,
      parent: 'miniPanelParent',
      trail: 'miniTrail',
      parentPanel: 'miniPanel',
      coinDefinition: 'BlueCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotLoWin',
    },
    16: {
      name: 'minor',
      index: 1,
      maxNodes: 2,
      parent: 'minorPanelParent',
      trail: 'minorTrail',
      parentPanel: 'minorPanel',
      coinDefinition: 'OrangeCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotLoWin',
    },
    17: {
      name: 'maxi',
      index: 2,
      maxNodes: 3,
      parent: 'maxiPanelParent',
      trail: 'maxiTrail',
      parentPanel: 'maxiPanel',
      coinDefinition: 'GreenCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotLoWin',
    },
    18: {
      name: 'major',
      index: 3,
      maxNodes: 4,
      parent: 'majorPanelParent',
      trail: 'majorTrail',
      parentPanel: 'majorPanel',
      coinDefinition: 'PurpleCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotLoWin',
    },
    19: {
      name: 'porker',
      index: 4,
      maxNodes: 5,
      parent: 'porkerPanelParent',
      trail: 'porkerTrail',
      parentPanel: 'porkerPanel',
      coinDefinition: 'GoldCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotHiWin',
    },
    20: {
      name: 'mega',
      index: 5,
      maxNodes: 6,
      parent: 'megaPanelParent',
      trail: 'megaTrail',
      parentPanel: 'megaPanel',
      coinDefinition: 'RedCoinSpin',
      targetX: -489,
      targetY: 61,
      soundToPlay: 'jackpotHiWin',
    },
  };

  class JackpotTrailView extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
    }

    initialise() {
      this._potValueMini = 0;
      this._potValueMinor = 0;
      this._potValueMaxi = 0;
      this._potValueMajor = 0;
      this._potValuePorker = 0;
      this._potValueMega = 0;
      this._trialProgressionCount = [0, 0, 0, 0, 0, 0];
      this._megaTrailParticle = null;
      this._porkerTrailParticle = null;
      this._majorTrailParticle = null;
      this._maxiTrailParticle = null;
      this._minorTrailParticle = null;
      this._miniTrailParticle = null;
      this._leftCoinMovie = null;
      this._rightCoinMovie = null;
      this._latestWinAmount = 0;
      this._justWonJackpot = false;
      this._winCapTriggered = false;

      // this one is for the middle of the panel
      // which now we ideally need to have in another container, which moves
      // based on layout
      // landscape and portrait are fine, its landscape_mobile which is the pita
      this._megaTrailParticle = particleManager.createEmitter(
        'megaTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:megaPanelParent:megaEmitterContainer`),
        -50,
        -10,
        false
      );
      this._megaTrailParticle.scale.set(0.8);
      this._megaTrailParticle.particleEmitter.emit = false;

      // the small one is for the trail increment
      this._megaTrailSmallParticle = particleManager.createEmitter(
        'megaTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:megaPanelParent`),
        -50,
        -10,
        false
      );
      this._megaTrailSmallParticle.scale.set(0.5);
      this._megaTrailSmallParticle.particleEmitter.emit = false;

      this._porkerTrailParticle = particleManager.createEmitter(
        'porkerTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:porkerPanelParent:porkerEmitterContainer`),
        -50,
        -10,
        false
      );
      this._porkerTrailParticle.scale.set(0.8);
      this._porkerTrailParticle.particleEmitter.emit = false;

      this._porkerTrailSmallParticle = particleManager.createEmitter(
        'porkerTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:porkerPanelParent`),
        -50,
        -10,
        false
      );
      this._porkerTrailSmallParticle.scale.set(0.5);
      this._porkerTrailSmallParticle.particleEmitter.emit = false;

      this._majorTrailParticle = particleManager.createEmitter(
        'majorTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:majorPanelParent:majorEmitterContainer`),
        -50,
        -10,
        false
      );
      this._majorTrailParticle.scale.set(0.8);
      this._majorTrailParticle.particleEmitter.emit = false;

      this._majorTrailSmallParticle = particleManager.createEmitter(
        'majorTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:majorPanelParent`),
        -50,
        -10,
        false
      );
      this._majorTrailSmallParticle.scale.set(0.5);
      this._majorTrailSmallParticle.particleEmitter.emit = false;

      this._maxiTrailParticle = particleManager.createEmitter(
        'maxiTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:maxiPanelParent:maxiEmitterContainer`),
        -50,
        -10,
        false
      );
      this._maxiTrailParticle.scale.set(0.8);
      this._maxiTrailParticle.particleEmitter.emit = false;

      this._maxiTrailSmallParticle = particleManager.createEmitter(
        'maxiTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:maxiPanelParent`),
        -50,
        -10,
        false
      );
      this._maxiTrailSmallParticle.scale.set(0.5);
      this._maxiTrailSmallParticle.particleEmitter.emit = false;

      this._minorTrailParticle = particleManager.createEmitter(
        'minorTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:minorPanelParent:minorEmitterContainer`),
        -50,
        -10,
        false
      );
      this._minorTrailParticle.scale.set(0.8);
      this._minorTrailParticle.particleEmitter.emit = false;

      this._minorTrailSmallParticle = particleManager.createEmitter(
        'minorTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:minorPanelParent`),
        -50,
        -10,
        false
      );
      this._minorTrailSmallParticle.scale.set(0.5);
      this._minorTrailSmallParticle.particleEmitter.emit = false;

      this._miniTrailParticle = particleManager.createEmitter(
        'miniTrailParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:miniPanelParent:miniEmitterContainer`),
        -50,
        -10,
        false
      );
      this._miniTrailParticle.scale.set(0.8);
      this._miniTrailParticle.particleEmitter.emit = false;

      this._miniTrailSmallParticle = particleManager.createEmitter(
        'miniTrailSmallParticle',
        resourceManager.get(`${JACKPOT_BASE_PATH}:miniPanelParent`),
        -50,
        -10,
        false
      );
      this._miniTrailSmallParticle.scale.set(0.5);
      this._miniTrailSmallParticle.particleEmitter.emit = false;

      this._potDisplay = resourceManager.get('mainReelsContainer:potDisplay');

      // Mini
      this._miniText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:miniPanelParent:miniPanel:cashpotText'
      );
      this._miniLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:miniPanelParent:miniPanelLeft:cashpotText'
      );
      this._miniTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:miniPanelParent:miniPanel:cashpotTextOverlay'
      );

      // Minor
      this._minorText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:minorPanelParent:minorPanel:cashpotText'
      );
      this._minorLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:minorPanelParent:minorPanelLeft:cashpotText'
      );
      this._minorTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:minorPanelParent:minorPanel:cashpotTextOverlay'
      );

      // Maxi
      this._maxiText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:maxiPanelParent:maxiPanel:cashpotText'
      );
      this._maxiLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:maxiPanelParent:maxiPanelLeft:cashpotText'
      );
      this._maxiTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:maxiPanelParent:maxiPanel:cashpotTextOverlay'
      );

      // Major
      this._majorText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:majorPanelParent:majorPanel:cashpotText'
      );
      this._majorLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:majorPanelParent:majorPanelLeft:cashpotText'
      );
      this._majorTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:majorPanelParent:majorPanel:cashpotTextOverlay'
      );

      // Porker
      this._porkerText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:porkerPanelParent:porkerPanel:cashpotText'
      );
      this._porkerLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:porkerPanelParent:porkerPanelLeft:cashpotText'
      );
      this._porkerTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:porkerPanelParent:porkerPanel:cashpotTextOverlay'
      );

      // Mega
      this._megaText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:megaPanelParent:megaPanel:cashpotText'
      );
      this._megaLeftText = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:megaPanelParent:megaPanelLeft:cashpotText'
      );
      this._megaTextOverlay = resourceManager.get(
        'mainReelsContainer:potDisplay:potDisplayContainer:cashpotMeters:megaPanelParent:megaPanel:cashpotTextOverlay'
      );

      this._starburstContainer = resourceManager.get('mainReelsContainer:starburstContainer');

      this._starburstSprite = resourceManager.get('mainReelsContainer:starburstContainer:starburstSprite');

      this._jackpotTitleMovie = resourceManager.get(
        'mainReelsContainer:starburstContainer:starburstSprite:jackpotTitleMovie'
      );
      this._jackpotTitleMovie.gotoAndStop(0);

      this.hideTrails();

      Reflex.registerEventHandler('orientationChange', () => {
        this.onOrientationChange();
      });
    }

    setJPTrailInfo(data) {
      this._shutterInfo = data;
    }

    hideTrails() {
      // Use JACKPOT_CONFIG to set visibility for all jackpot trails with pop animation
      Object.values(JACKPOT_CONFIG).forEach((config) => {
        const trail = resourceManager.get(`${JACKPOT_BASE_PATH}:${config.parent}:${config.trail}`);
        trail.visible = false;
      });
    }

    setJPTrailVisibility(visible) {
      // Use JACKPOT_CONFIG to set visibility for all jackpot trails with pop animation
      const trails = [];
      Object.values(JACKPOT_CONFIG).forEach((config) => {
        const trail = resourceManager.get(`${JACKPOT_BASE_PATH}:${config.parent}:${config.trail}`);
        if (trail) {
          trails.push(trail);
        }
      });

      if (visible) {
        // Pop in animation
        trails.forEach((trail, index) => {
          // Set initial state
          trail.scale.set(0);
          trail.alpha = 0;
          trail.visible = true;

          // Animate with stagger effect
          gsap.to(trail, {
            duration: 0.5,
            delay: index * 0.05,
            pixi: {
              scale: 1,
              alpha: 1,
            },
            ease: 'elastic.out(1, 0.5)',
          });
        });
      } else {
        // Pop out animation
        trails.forEach((trail, index) => {
          gsap.to(trail, {
            duration: 0.3,
            delay: index * 0.03,
            pixi: {
              scale: 0,
              alpha: 0,
            },
            ease: 'back.in(2)',
            onComplete: () => {
              trail.visible = false;
            },
          });
        });
      }
    }

    getNodeXY(symbolID, adjustCoordsTo, useParent = true) {
      const config = JACKPOT_CONFIG[symbolID];
      const index = this._trialProgressionCount[config.index] + 1;
      const node = resourceManager.get(`${JACKPOT_BASE_PATH}:${config.parent}:${config.trail}:id_${index}`);
      let xy = {
        x: node ? node.x : 0,
        y: node ? node.y : 0,
      };

      if (adjustCoordsTo) {
        // we need to adjust this coords as if they were on the same layer
        const stage = systemData.stage;
        if (useParent) {
          xy = adjustCoordsTo.parent.toLocal(node.toGlobal(stage));
          xy.y -= 20; // random y offset, no idea why - ah there is a slight scale
        } else {
          xy = adjustCoordsTo.toLocal(node.toGlobal(stage));
        }
      }
      return xy;
    }

    resetJackpotTrailNodes() {
      this._trialProgressionCount = [0, 0, 0, 0, 0, 0];

      // Hide all trail node indicators using JACKPOT_CONFIG
      Object.values(JACKPOT_CONFIG).forEach((config) => {
        for (let i = 1; i <= config.maxNodes; i++) {
          const node = resourceManager.get(`${JACKPOT_BASE_PATH}:${config.parent}:${config.trail}:id_${i}`);
          if (node) {
            node.visible = false;
          }
        }
      });
    }

    async lightUpJackpotTrailNode(coinSymbol) {
      // get the config for this coin symbol
      const config = JACKPOT_CONFIG[coinSymbol];

      // lets reposition the particle effect
      const emitter = this.getAssociatedSmallParticleEffect(coinSymbol);
      const xy = this.getNodeXY(coinSymbol, emitter.parent, false);
      emitter.x = xy.x;
      emitter.y = xy.y;

      // Update progression count (cycles back to 1 after reaching max)
      this._trialProgressionCount[config.index] = (this._trialProgressionCount[config.index] % config.maxNodes) + 1;
      const currentProgress = this._trialProgressionCount[config.index];

      this.playParticleEffect(coinSymbol, true);
      this.updateNodeProgressionLights(config, currentProgress);

      if (currentProgress === config.maxNodes) {
        // Check if this jackpot is win-capped and set flag immediately to prevent win animations
        const jackpotData = gameController.spinTask.data.trailLevelData.jackpotTrails;
        const isWinCapped = jackpotData.trails[config.index].winCapped;
        if (isWinCapped) {
          gameController.meterFullyUpdated = true;
        }

        await timerManager.delayAsync(500);
        soundManager.play(config.soundToPlay);
        this.playParticleEffect(coinSymbol);
        await this.moveJPValueToCentreScreen(config);
        this._trialProgressionCount[config.index] = 0;
        this.updateNodeProgressionLights(config, this._trialProgressionCount[config.index]);

        // Return whether win cap was triggered
        return this._winCapTriggered;
      }

      return false;
    }

    getWinCapTriggered() {
      return this._winCapTriggered;
    }

    resetWinCapTriggered() {
      this._winCapTriggered = false;
    }

    // Update visibility for all nodes in this jackpot's trail
    updateNodeProgressionLights(config, currentProgress) {
      for (let i = 1; i <= config.maxNodes; i++) {
        const node = resourceManager.get(`${JACKPOT_BASE_PATH}:${config.parent}:${config.trail}:id_${i}`);
        if (node) {
          node.visible = i <= currentProgress;
        }
      }
    }

    async moveJPValueToCentreScreen(config) {
      const animId = Date.now();

      let text = undefined;
      let textLeft = undefined;
      let overlayText = undefined;
      let value = 0;
      let newValue = 0;

      const jackpotData = gameController.spinTask.data.trailLevelData.jackpotTrails;

      switch (config.name) {
        case 'mini': {
          text = this._miniText;
          textLeft = this._miniLeftText;
          overlayText = this._miniTextOverlay;
          value = jackpotData.trails[0].winCash;
          newValue = jackpotData.trails[0].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[0].winCapped;
          this._jackpotTitleMovie.gotoAndStop(0);
          break;
        }
        case 'minor': {
          text = this._minorText;
          textLeft = this._minorLeftText;
          overlayText = this._minorTextOverlay;
          value = jackpotData.trails[1].winCash;
          newValue = jackpotData.trails[1].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[1].winCapped;
          this._jackpotTitleMovie.gotoAndStop(1);
          break;
        }
        case 'maxi': {
          text = this._maxiText;
          textLeft = this._maxiLeftText;
          overlayText = this._maxiTextOverlay;
          value = jackpotData.trails[2].winCash;
          newValue = jackpotData.trails[2].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[2].winCapped;
          this._jackpotTitleMovie.gotoAndStop(2);
          break;
        }
        case 'major': {
          text = this._majorText;
          textLeft = this._majorLeftText;
          overlayText = this._majorTextOverlay;
          value = jackpotData.trails[3].winCash;
          newValue = jackpotData.trails[3].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[3].winCapped;
          this._jackpotTitleMovie.gotoAndStop(3);
          break;
        }
        case 'porker': {
          text = this._porkerText;
          textLeft = this._porkerLeftText;
          overlayText = this._porkerTextOverlay;
          value = jackpotData.trails[4].winCash;
          newValue = jackpotData.trails[4].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[4].winCapped;
          this._jackpotTitleMovie.gotoAndStop(4);
          break;
        }
        case 'mega': {
          text = this._megaText;
          textLeft = this._megaLeftText;
          overlayText = this._megaTextOverlay;
          value = jackpotData.trails[5].winCash;
          newValue = jackpotData.trails[5].currentJackpotCash;
          this._winCapTriggered = jackpotData.trails[5].winCapped;
          this._jackpotTitleMovie.gotoAndStop(5);
          break;
        }
      }

      this._potDisplay.positionOverlaysOverText();

      const overlayOrigParent = overlayText.parent;
      const originalX = overlayText.x;
      const originalY = overlayText.y;
      const originalScale = overlayText.scale.x;

      let targetScale = 1;
      if (overlayText.text.length >= 12) {
        targetScale = 0.7;
      }

      // Calculate dynamic coin positions based on text width
      const coinSpacing = 80 * targetScale;
      const coinYOffset = 0;

      // Calculate coin positions relative to where text will animate to
      const overlayTextWidth = ((overlayText.width * (1 / overlayText.scale.x)) / 2) * targetScale;
      const leftCoinTargetX = 0 - overlayTextWidth - coinSpacing;
      const rightCoinTargetX = 0 + overlayTextWidth + coinSpacing;
      const coinTargetY = 0 + coinYOffset;

      let leftCoinMovie = resourceManager.createObject(
        'movie',
        `${config.name}_LeftCoinMovie_${animId}`,
        this._starburstSprite,
        {
          definition: `${config.coinDefinition}`,
          scale: 0.3,
          anchor: 0.5,
          visible: false,
          x: leftCoinTargetX,
          y: coinTargetY,
          alpha: 1,
        }
      );

      let rightCoinMovie = resourceManager.createObject(
        'movie',
        `${config.name}_RightCoinMovie_${animId}`,
        this._starburstSprite,
        {
          definition: `${config.coinDefinition}`,
          scale: 0.3,
          anchor: 0.5,
          visible: false,
          x: rightCoinTargetX,
          y: coinTargetY,
          alpha: 1,
        }
      );

      const stage = systemData.stage;

      // before we do anything
      // reparent the overlay text
      // this will make sure its over the starburst and over any other coins
      // on the reel
      // we also need to convert existing coords
      const textPos = this._starburstContainer.toLocal(overlayText.toGlobal(stage));
      this._starburstContainer.addChild(overlayText);
      overlayText.x = textPos.x;
      overlayText.y = textPos.y;

      this._starburstContainer.visible = true;
      this._starburstSprite.alpha = 0;

      text.visible = false;
      textLeft.visible = false;
      overlayText.visible = true;

      // now we need to calculate coords - not now we are already parented
      let newPosForText = { x: 0, y: 0 }; //overlayText.parent.toLocal(this._starburstSprite.toGlobal(stage));

      // Combine position and scale animations into a single tween
      const animationProps = {
        duration: 1,
        x: newPosForText.x,
        y: newPosForText.y,
      };

      // rather then use a time line, lets just use tweens which we can await on
      // and tweens we can progress to 100% on orientation changes
      this.scaleOverlayTextUpTween = gsap.to(overlayText.scale, {
        x: targetScale,
        y: targetScale,
        duration: 1,
      });

      const fontYOffsetAdjustment = 9;
      this.moveOverlayTextToMiddleTween = gsap.to(overlayText, {
        x: newPosForText.x,
        y: newPosForText.y - fontYOffsetAdjustment,
        duration: 1,
      });

      leftCoinMovie.gotoAndPlay(0);
      rightCoinMovie.gotoAndPlay(0);

      await Promise.all([this.scaleOverlayTextUpTween, this.moveOverlayTextToMiddleTween]);

      // newPosForText = overlayText.parent.toLocal(this._starburstSprite.toGlobal(stage));
      // overlayText.x = newPosForText.x;
      // overlayText.y = newPosForText.y;

      // now we can fade in
      leftCoinMovie.visible = true;
      rightCoinMovie.visible = true;

      this.fadeInStarBurstTween = gsap.fromTo(
        [this._starburstSprite, leftCoinMovie, rightCoinMovie],
        { alpha: 0 },
        {
          duration: 0.8,
          alpha: 1,
        }
      );

      await this.fadeInStarBurstTween;

      this._justWonJackpot = true;

      // When win-capped, use full spin winAmount to include line wins in one meter update
      let amountToAdd = value;
      if (this._winCapTriggered) {
        // Win-capped: calculate amount including all remaining wins to reach winAmountSoFar
        const winAmountSoFar = gameController.spinTask.data.freeSpinsData.winAmountSoFar;
        amountToAdd = winAmountSoFar - gameController.totalWinnings;
      }

      this.addLatestWinAmount(amountToAdd);

      // wait a bit before removing
      await timerManager.delayAsync(500);

      this._starburstContainer.origY = this._starburstContainer.y;
      this.moveOverlayAndStarburstDownTween = gsap.to([this._starburstContainer], {
        duration: 0.3,
        y: '+=700',
        ease: 'power2.in',
      });

      await this.moveOverlayAndStarburstDownTween;

      // Destroy all created elements
      if (leftCoinMovie) {
        leftCoinMovie.destroy();
      }
      if (rightCoinMovie) {
        rightCoinMovie.destroy();
      }

      // how many different f'ing names do we need for these jackpots!?!?!
      switch (config.name) {
        case 'mini': {
          this._potDisplay.setPotText('Mini', newValue);
          break;
        }
        case 'minor': {
          this._potDisplay.setPotText('Minor', newValue);
          break;
        }
        case 'maxi': {
          this._potDisplay.setPotText('Maxi', newValue);
          break;
        }
        case 'major': {
          this._potDisplay.setPotText('Major', newValue);
          break;
        }
        case 'porker': {
          this._potDisplay.setPotText('Porker', newValue);
          break;
        }
        case 'mega': {
          this._potDisplay.setPotText('Mega', newValue);
          break;
        }
      }

      overlayOrigParent.addChild(overlayText);
      overlayText.x = originalX;
      overlayText.y = originalY;
      overlayText.scale.set(originalScale);
      text.visible = true;
      textLeft.visible = true;
      overlayText.visible = false;
      this._starburstContainer.visible = false;
      this._starburstContainer.y = this._starburstContainer.origY;
    }

    // When a Jackpot is awarded, add the amount to the winnings meter
    addLatestWinAmount(amount) {
      this._latestWinAmount = amount;
      if (this._justWonJackpot) {
        // soundManager.play('creditCountUp');
        gameData.winningsMeter.countUp(this._latestWinAmount, 300, () => {
          // soundManager.stop('creditCountUp');
          // soundManager.play('creditCountUpEnd');
        });
        gameController.totalWinnings += this._latestWinAmount;
        gameController.handleSoundLevel();
        this._justWonJackpot = false;
      }
    }

    getAssociatedSmallParticleEffect(coinSymbol) {
      // emit particle effect for specific pots
      let emitter = null;
      switch (coinSymbol) {
        case 20:
          emitter = this._megaTrailSmallParticle;
          break;
        case 19:
          emitter = this._porkerTrailSmallParticle;
          break;
        case 18:
          emitter = this._majorTrailSmallParticle;
          break;
        case 17:
          emitter = this._maxiTrailSmallParticle;
          break;
        case 16:
          emitter = this._minorTrailSmallParticle;
          break;
        case 15:
          emitter = this._miniTrailSmallParticle;
          break;
      }

      return emitter;
    }

    playParticleEffect(coinSymbol, small = false) {
      // emit particle effect for specific pots
      let emitter = null;

      switch (coinSymbol) {
        case 20:
          emitter = small ? this._megaTrailSmallParticle : this._megaTrailParticle;
          break;
        case 19:
          emitter = small ? this._porkerTrailSmallParticle : this._porkerTrailParticle;
          break;
        case 18:
          emitter = small ? this._majorTrailSmallParticle : this._majorTrailParticle;
          break;
        case 17:
          emitter = small ? this._maxiTrailSmallParticle : this._maxiTrailParticle;
          break;
        case 16:
          emitter = small ? this._minorTrailSmallParticle : this._minorTrailParticle;
          break;
        case 15:
          emitter = small ? this._miniTrailSmallParticle : this._miniTrailParticle;
          break;
      }

      emitter.particleEmitter.emit = true;
    }

    getJPTrailInfo() {
      let fsNum = getFreeSpinsNum();
      return this._shutterInfo[fsNum];
    }

    getFreeSpinsNum() {
      return gameController.freeSpinsNum;
    }

    onOrientationChange() {
      if (this.scaleOverlayTextUpTween && this.scaleOverlayTextUpTween.isActive()) {
        this.scaleOverlayTextUpTween.progress(1);
      }
      if (this.moveOverlayTextToMiddleTween && this.moveOverlayTextToMiddleTween.isActive()) {
        this.moveOverlayTextToMiddleTween.progress(1);
      }
      if (this.fadeInStarBurstTween && this.fadeInStarBurstTween.isActive()) {
        this.fadeInStarBurstTween.progress(1);
      }
      // if (this.moveOverlayAndStarburstDownTween && this.moveOverlayAndStarburstDownTween.isActive()) {
      //   this.moveOverlayAndStarburstDownTween.progress(1);
      // }
    }
  }

  create = function (json) {
    return new JackpotTrailView();
  };

  getFilesRequired = function (json) {
    return [];
  };

  // Register controller with resource manager
  resourceManager.registerController('jackpotTrailView', function () {
    return new JackpotTrailView();
  });
})();
